import { component } from 'picoapp';

export default component((node) => {
  const input = node.querySelector('input');
  const count = node.querySelector('[data-quantity]');
  const minus = node.querySelector('[data-minus]');
  const plus = node.querySelector('[data-plus]');

  input.addEventListener('change', () => {
    count.textContent = input.value;
  });

  minus.addEventListener('click', () => {
    input.valueAsNumber -= 1;
    input.valueAsNumber = Math.max(input.valueAsNumber, 0);

    input.dispatchEvent(new Event('change'));
  });

  plus.addEventListener('click', () => {
    input.valueAsNumber += 1;

    input.dispatchEvent(new Event('change'));
  });
});
